export default {
  user: (state) => { return state.user },
  firebaseUser: (state) => { return state.firebaseUser }
};